enum MoneyRequestStatus {
  accepted = 'accepted',
  cancelled = 'cancelled',
  declined = 'declined',
  pending = 'pending',
  expired = 'expired',
  ignored = 'ignored',
}

export default MoneyRequestStatus;
